export default __webpack_public_path__ + "static/media/Class-9-10-CBSE-Science.b4aadbb1.pdf";